import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { colors, type, spacing, radius } from "@/theme";
import { CASES, CONTACT, MARA_PHOTO } from "@/content/site";
import { useWide } from "@/lib/useWide";
import SiteFooter from "@/components/SiteFooter";

export default function ChiSono() {
  const navigate = useNavigate();
  const wide = useWide();
  useEffect(() => { document.title = "Chi sono — Mariana Radova | Tavoline"; }, []);

  return (
    <div style={{ minHeight: "100vh", background: colors.paper }}>
      <div style={{ width: "100%", maxWidth: 960, margin: "0 auto", padding: `${spacing.md}px ${spacing.lg}px` }}>
        <button data-testid="chi-sono-home" onClick={() => navigate("/")} style={{ background: "none", border: "none", ...type.serif, fontSize: 22, color: colors.ink, padding: "8px 0" }}>← Tavoline</button>

        {/* Intro */}
        <div style={{ padding: `${spacing.xl}px 0`, borderBottom: `1px solid ${colors.rule}`, display: "flex", flexDirection: wide ? "row" : "column", alignItems: wide ? "center" : "stretch", gap: spacing.lg }}>
          <img src={MARA_PHOTO} alt="Foto di Mariana Radova" style={{ width: 240, height: 300, objectFit: "cover", borderRadius: radius.photo }} />
          <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: spacing.sm }}>
            <h1 style={{ ...type.serif, fontSize: 48, lineHeight: "52px", color: colors.ink, margin: 0 }}>Mariana Radova</h1>
            <p style={{ ...type.sans, fontSize: 18, lineHeight: "28px", color: colors.ink, margin: 0, maxWidth: 680 }}>Costruisco software e strumenti per le aziende italiane.</p>
            <p style={{ ...type.sans, fontSize: 18, lineHeight: "28px", color: colors.ink, margin: 0, maxWidth: 680 }}>Lavoro con l'intelligenza artificiale: mi permette di consegnare in settimane quello che di solito richiede mesi.</p>
            <p style={{ ...type.sans, fontSize: 18, lineHeight: "28px", color: colors.ink, margin: 0, maxWidth: 680 }}>Prima di passare al software ho fatto quindici anni di design.</p>
          </div>
        </div>

        <Section title="Perché Tavoline è gratis">
          <p style={bodyLarge}>Un'app come questa, in Italia, un ristoratore la paga dai mille ai cinquemila euro: se la fa sviluppare su misura, solo per sé. Ecco perché ce l'hanno quasi solo i ristoranti di sushi.</p>
          <p style={bodyLarge}>Io l'ho costruita in due settimane usando l'intelligenza artificiale. Avrei potuto venderla. Ho preferito regalarla: il menu digitale resta gratis per sempre, senza scadenze e senza carta di credito.</p>
          <p style={bodyLarge}>Il motivo è semplice. Dire "so fare le cose" non convince nessuno. Un ristorante che apre il proprio menu dal tavolo, e una comanda che arriva in cucina senza che nessuno si alzi, sì. Tavoline è il modo più onesto che ho per far vedere come lavoro.</p>
        </Section>

        <Section title="Cosa ho costruito">
          <div style={{ display: "flex", flexWrap: "wrap", gap: spacing.lg }}>
            {CASES.map((c) => (
              <div key={c.title} data-testid={`case-${c.title}`} style={{ width: wide ? "47%" : "100%", display: "flex", flexDirection: "column", gap: spacing.sm }}>
                <div style={{ width: "100%", aspectRatio: "16 / 10", borderRadius: radius.photo, border: `1px solid ${colors.rule}`, background: c.image ? `url(${c.image}) center/cover` : colors.paperDeep }} />
                <div style={{ ...type.serif, fontSize: 26, color: colors.ink, marginTop: spacing.xs }}>{c.title}</div>
                <div style={{ ...type.sans, fontSize: 16, lineHeight: "24px", color: colors.ink }}>{c.what}</div>
                <div style={{ ...type.sansBold, fontSize: 15, color: colors.ink }}>{c.time}</div>
              </div>
            ))}
          </div>
        </Section>

        <Section title="Se hai un'altra attività">
          <p style={bodyLarge}>Faccio siti, app e strumenti su misura. Se hai un'altra impresa oltre al locale e ti serve qualcosa, scrivimi: ti dico subito se posso aiutarti e quanto costa.</p>
        </Section>

        <div style={{ padding: `${spacing.xxl}px 0`, display: "flex", flexDirection: "column", gap: spacing.md }}>
          <h2 style={h2Style}>Scrivimi</h2>
          <a data-testid="contact-email" href={`mailto:${CONTACT.email}`} style={{ ...type.sansSemi, fontSize: 17, color: colors.onAccent, backgroundColor: colors.accent, minHeight: 56, display: "inline-flex", alignItems: "center", justifyContent: "center", borderRadius: radius.md, padding: `0 ${spacing.lg}px`, alignSelf: "flex-start", textDecoration: "none" }}>
            {CONTACT.email}
          </a>
        </div>

        <SiteFooter />
      </div>
    </div>
  );
}

const h2Style = { fontFamily: '"Instrument Serif", Georgia, serif', fontWeight: 400, fontSize: 34, lineHeight: "38px", color: colors.ink, margin: 0 };
const bodyLarge = { ...type.sans, fontSize: 18, lineHeight: "28px", color: colors.ink, margin: 0, maxWidth: 680 };

function Section({ title, children }) {
  return (
    <div style={{ padding: `${spacing.xxl}px 0`, borderBottom: `1px solid ${colors.rule}`, display: "flex", flexDirection: "column", gap: spacing.md }}>
      <h2 style={h2Style}>{title}</h2>
      {children}
    </div>
  );
}
